<main id="foundation_main">
  <!-- <app-navbar></app-navbar> -->

  <div id="container">
    <h1 id="title">Quarenta Anos</h1>

    <!--<div id="content">
      <div id="pink-box"></div>

      <div id="pink-line"></div>

      <div id="blue-box"><strong>ABRIL</strong></div>

      <div id="beige-box">
        <p id="title-text-pink"><strong>QUARTA-FEIRA, 26</strong></p>
        <p id="title-text-pink">Pilotis da Ala Kennedy - PUC-Rio</p>
        <br />
        <p id="title-text-pink">16:00 - Dimensão Histórica</p>
        <p id="sub-title-text-blue">Mediação - Pe. Roberto Barros Dias, S.J.</p>
        <br />
        <p id="sub-title-text-blue">EVENTO</p>
        <p id="sub-title-text-blue"><strong>Abertura:</strong></p>
        <p id="sub-title-text-blue">
          Palavra do Reitor e do Presidente da FPLF
        </p>
        <br />
        <p id="sub-title-text-blue">
          <strong>Conferência de Abertura:</strong>
        </p>
        <p id="sub-title-text-blue">
          FPLF - 40 anos de história: tecendo sonhos e possibilidades
        </p>
        <p id="sub-title-text-blue">
          a. A Fundação e seus Projetos: desenvolvimento e inovação — Prof.
          Marcelo Gattass
        </p>
        <p id="sub-title-text-blue">
          b. A Pesquisa e a Extensão: A PUC e a FPLF parceiras na
          responsabilidade Social — Profa. Jackeline Farbiarz
        </p>
        <p id="sub-title-text-blue">
          c. Ações Comunitárias: Responsabilidade Social — Prof. Augusto
          Sampaio
        </p>
        <p id="sub-title-text-blue">
          Homenagens: Professor Carlos Lucena e Sr. Carlos Baptista Leyes
        </p>
        <br />
        <p id="title-text-pink">18:00 - Orquestra Sinfônica Jovem do Rio de Janeiro</p>
        <p id="sub-title-text-blue">(Residente da PUC-Rio)</p>
        <br />
         <p id="title-text-pink">
          18:00 - Lucernário I Igreja do Sagrado Coração de Jesus
        </p>
        <p id="sub-title-text-blue">
          Lançamento do Concurso Cultural FPLF 40 anos
        </p> 
      </div>
    </div>

    <div id="content">
      <div id="pink-box"></div>

      <div id="pink-line"></div>

      <div id="blue-box"><strong>MAIO</strong></div>

      <div id="beige-box">
        <p id="title-text-pink"><strong>SEXTA-FEIRA, 5</strong></p>
        <br />
        <p id="title-text-pink">
          16:00 - Movimento de transferência da Medalha do Padre Leonel Franca
          para o Edifício FPLF
        </p>
        <br />
        <p id="title-text-pink"><strong>QUARTA-FEIRA, 24</strong></p>
        <p id="title-text-pink"><strong>Auditório do RDC</strong></p>
        <br />
        <p id="title-text-pink">16:00 - Dimensão Acadêmica</p>
        <p id="sub-title-text-blue">Mediação - Profa. Marley Vellasco,</p>
        <br />
        <br />
        <p id="sub-title-text-blue">EVENTO</p>
        <p id="sub-title-text-blue">
          a. Inspirações a partir do Pacto Educativo Global à luz da Pedagogia
          Inaciana - Pe. Luiz Fernando Klein, S. J.
        </p>
        <p id="sub-title-text-blue">
          b. Estímulos, reflexões e ações: inovação, infraestrutura, tecnologia,
          educação e sustentabilidade - Prof. Luiz Fernando Martha, Pe. Paulo
          Veríssimo, Profa. Roberta Portas, Profa. Erica Rodrigues
        </p>
        <br />
        <p id="sub-title-text-blue">
          Homenagens: Pe. Laércio Dias de Moura, S.J. e o Professor José Pelúcio
          Ferreira
        </p>
        <br />
        <p id="title-text-pink">18:00 - Convite ao Lucernário</p>
        <p id="sub-title-text-blue">Igreja Sagrado Coração de Jesus</p>
      </div>
    </div>

    <div id="content">
      <div id="pink-box"></div>

      <div id="pink-line"></div>

      <div id="blue-box"><strong>JUNHO</strong></div>

      <div id="beige-box">
        <p id="title-text-pink"><strong>QUARTA-FEIRA, 21</strong></p>
        <p id="title-text-pink"><strong>Auditório do RDC</strong></p>
        <br />
        <p id="title-text-pink">16:00 — Identidade e Missão</p>
        <p id="sub-title-text-blue">Mediação - Pe. Anderson Pedroso, S.J.</p>
        <br />
        <br />
        <p id="sub-title-text-blue">EVENTO</p>
        <p id="sub-title-text-blue">
          a. Identidade e Missão das Universidades confiadas à Companhia de
          Jesus - Pe. Sergio Mariucci, S.J.
        </p>
        <p id="sub-title-text-blue">
          b. Entre culturas: a Companhia de Jesus no Brasil - Pe. Elton Vitoriano Ribeiro, S.J.
        </p>
        <p id="sub-title-text-blue">
          c. Apresentação AUSJAL — foco Brasil - Pe. André Araújo, S.J.
        </p>
        <br />
        <br />
        <p id="title-text-pink">18:00 - Convite ao Lucernário</p>
        <p id="sub-title-text-blue">Igreja Sagrado Coração de Jesus</p>
        <br />
        <p id="sub-title-text-blue">
          Homenagem: Pe. Pedro Magalhães Guimarães, S.J.
        </p>
      </div>
    </div>

    <div id="content">
      <div id="pink-box"></div>

      <div id="pink-line"></div>

      <div id="blue-box"><strong>AGOSTO</strong></div>

      <div id="beige-box">
        <p id="title-text-pink"><strong>SÁBADO, 19</strong></p>
        <br />
        <br />
        <p id="title-text-pink">7:30 - Caminhada na Lagoa*</p>
        <p id="sub-title-text-blue">
          Prof.ª Jô Santos , Prof. Renato, Prof. Marcelo Motta, Josemar
          Gouvêa/FPLF
        </p>
        <br />
        <br />
        <p id="title-text-pink"><strong>QUARTA-FEIRA, 23</strong></p>
        <p id="title-text-pink"><strong>Auditório do RDC</strong></p>
        <br />
        <p id="title-text-pink">16:00 - Dimensão Humana e Mística</p>
        <p id="sub-title-text-blue">Mediação - Pe. André Araújo, S.J.</p>
        <br />
        <br />
        <p id="sub-title-text-blue">EVENTO</p>
        <p id="sub-title-text-blue">
          a. Acolher e cuidar: respostas para uma crise sistêmica (Prof.ª Maria
          Clara Bingemer)
        </p>
        <p id="sub-title-text-blue">
          b. Projeto de Vida: a Espiritualidade Inaciana tecendo afetos (Prof.ª
          Vanessa Correia)
        </p>
        <br />
        <br />
        <p id="title-text-pink">18:00 - Convite ao Lucernário</p>
        <p id="sub-title-text-blue">Igreja Sagrado Coração de Jesus</p>
        <br />
        <br />
        <p id="title-text-pink">
          *No caso de chuva, o evento será dia 2 de setembro
        </p>
      </div>
    </div>-->

    <div id="content">
      <div id="pink-box"></div>

      <div id="pink-line"></div>

      <div id="blue-box"><strong>SETEMBRO</strong></div>

      <div id="beige-box">
        <p id="title-text-pink"><strong>SEXTA-FEIRA, 15</strong></p>
        <br />
        <br />

        <p id="title-text-pink">11:30 - Descerramento do novo busto do Pe. Leonel Franca, S.J.</p>
        <p id="sub-title-text-blue">Em frente aos Mastros da Entrada: Avenida Padre Leonel Franca-PUC-Rio</p>
        <br />
        <br />
        <p id="title-text-pink">12:00 - Missa</p>
        <p id="sub-title-text-blue">Dom Orani João Tempesta, O. Cist.</p>
        <p id="sub-title-text-pink">Igreja Sagrado Coração de Jesus</p>
        <br />
        <br />
        <p id="title-text-pink">16:00 - EVENTO</p>
        <p id="sub-title-text-blue">Fundação Padre Leonel Franca 40 anos: Tecendo sonhos e possibilidades</p>
        <p id="sub-title-text-pink">Pilotis Ala Kennedy</p>
        <br />
        <p id="sub-title-text-blue">
          a. Pe. Anderson Antonio Pedroso, S.J. (Reitor da PUC-Rio)</p>
        <p id="sub-title-text-blue">
          b. Pe. Miêczysláw Smýda, S.J. (Provincial dos Jesuítas do Brasil)</p>
        <p id="sub-title-text-blue">
          c. Pe. Roberto Barros Dias, S.J.  (Presidente da Fundação Padre Leonel Franca)</p>
        <br />
        <p id="sub-title-text-blue">
          d. Abertura da Exposição e Lançamento do Livro: Leonel Franca</p>
        <p id="sub-title-text-blue">
          e. História e Mostra Cultural:  Pe. André Araújo, S.J. (Vice Reitor Geral)</p>    
        <br />
        <br />
        <br />
        <p id="title-text-pink">18:00 - Orquestra Sinfônica Jovem do Rio de Janeiro</p>
        <p id="sub-title-text-blue">(Residente da PUC-Rio)</p>
      </div>
    </div>
  </div>

  <!-- <app-footer></app-footer> -->
</main>